import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { UserModel } from 'src/models/Account/User';
import { MyAccountLink } from 'src/routes';
import { SignOutButtonComponent } from './SignOutButton';

type LettersLogoProps = {
  firstName: string | null;
  lastName: string | null;
};

const LettersLogo = ({ lastName, firstName }: LettersLogoProps) =>
  lastName && firstName ? (
    <div className="img-circle letters HeaderIconColorBg">{`${firstName[0]}${lastName[0]}`}</div>
  ) : null;

type UserPopupProps = {
  user: UserModel;
  onClose: () => void;
};

export const HeaderUserPopupContent: React.FC<UserPopupProps> = memo(({ user, onClose }: UserPopupProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="my-account-popover-content">
        {user.imageUri ? (
          <img className="img-circle" alt="" src={user.imageUri} loading="lazy" />
        ) : (
          <LettersLogo lastName={user.lastName} firstName={user.firstName} />
        )}
        <div className="user-info">
          <div className="user-name">
            {user.firstName} {user.lastName}
          </div>
          <div className="user-email">{user.email}</div>
          <div className="user-org-id">
            {user.organizationIdString && t('header.account.orgIdShort', { organization: user.organizationIdString })}
          </div>
        </div>
      </div>
      <div className="my-account-popover-bottom">
        {user.canViewMyAccountButton && (
          <MyAccountLink
            text={t('header.account.myAccount')}
            className="to-account"
            data-test="myAccountButton"
            onClick={onClose}
          />
        )}
        <SignOutButtonComponent />
      </div>
    </>
  );
});
